import { Component, Fragment } from 'react';
import ReactModal from '../../../../components/Modal';
import { CHECKBOX_ITEMS } from '../../../UserCancelation/config';
import { cancelationQuery, stayAndStayQuery } from './query';
import { showMessage } from '../../../../helpers/showMessage';
import Loading from '../../../../components/Loading';

class SpecialOfferModal extends Component {
    constructor(props) {
        super(props);

        this.onChangeTextarea = this.onChangeTextarea.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onStayAndSave = this.onStayAndSave.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.isDisabledButton = this.isDisabledButton.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.cancelationHandler = this.cancelationHandler.bind(this);

        this.state = {
            feedback: [],
            textareaValue: '',
            isLoading: false,
            isOpenModal: false,
        };
    }

    selectAll() {
        if (this.state.allSelect) {
            this.setState({
                feedback: [],
                allSelect: false,
            });
        } else {
            this.setState({
                feedback: CHECKBOX_ITEMS,
                allSelect: true,
            });
        }
    }

    onCheck(e) {
        const value = e.target.value;
        if (this.state.feedback.includes(value)) {
            this.setState({
                feedback: this.state.feedback.filter((item) => item !== value),
                allSelect: false,
            });
        } else {
            const newItems = [...this.state.feedback, value];
            this.setState({
                feedback: newItems,
                allSelect: newItems.length === CHECKBOX_ITEMS.length,
            });
        }
    }

    onChangeTextarea(e) {
        this.setState({
            textareaValue: e.target.value,
        });
    }

    async onStayAndSave() {
        try {
            this.setState({
                isLoading: true,
            });
            const response = await stayAndStayQuery();
            const resData = await response.json();
            if (response.status === 200) {
                showMessage('Request processed successfully.', 'success');
                window.location.href = '/';
            } else {
                showMessage(resData?.message || 'Error processing your request.', 'error');
                this.setState({
                    isLoading: false,
                });
            }
        } catch (err) {
            console.log('error', err);
            showMessage(err?.message || 'Error processing your request.', 'error');
            this.setState({
                isLoading: false,
            });
        }
    }

    async cancelationHandler() {
        try {
            this.setState({
                cancelationLoading: true,
            });
            const response = await cancelationQuery();
            console.log('response', response);
            const resData = await response.json();
            if (response.status === 200) {
                showMessage('Your Subscription has been successfully canceled.', 'success');
                window.location.href = '/';
            } else {
                showMessage(resData?.message || 'Error processing your request.', 'error');
            }
        } catch (err) {
            showMessage(err?.message || 'Error processing your request.', 'error');
        } finally {
            this.setState({
                cancelationLoading: false,
            });
        }
    }

    onCloseModal() {
        this.setState({
            isOpenModal: false,
        });
    }
    onOpenModal() {
        this.setState({
            isOpenModal: true,
        });
    }

    deleteMessage() {
        this.setState({
            message: '',
            message_tag: '',
        });
    }

    isDisabledButton() {
        if (this.state.isLoading) return true;
        if (this.state.feedback.includes(CHECKBOX_ITEMS[8]) && !this.state.textareaValue)
            return true;
        if (!this.state.textareaValue && this.state.feedback?.length === 0) return true;
        return false;
    }

    render() {
        return (
            <>
                <ReactModal
                    modalState={this.props.isOpenModal}
                    className="width-sm change-plan-special-offer-modal-wrapper"
                    onClose={this.props.onCloseModal}
                >
                    <div className="change-plan-special-offer-modal">
                        <div className="change-plan-special-offer-modal-header">
                            Wait! Before you cancel
                        </div>
                        <div className="change-plan-special-offer-modal-subheader">
                            Stay and save 25% for the next 12 months
                        </div>
                        <div className="change-plan-special-offer-modal-info">
                            Keep access to your current plan and all its features for the next 12
                            months at a discounted rate of 25%. No commitments, cancel anytime.
                        </div>
                        <div className="change-plan-special-offer-modal-offer">
                            <div className="change-plan-special-offer-modal-offer-discount">
                                <div>25%</div> <span>OFF</span>
                            </div>
                            <div className="change-plan-special-offer-modal-offer-details">
                                <div className="change-plan-special-offer-modal-offer-details-header">
                                    For the next 12 months
                                </div>
                                <div className="change-plan-special-offer-modal-offer-details-subheader">
                                    You'll get 25% off your subscription for the next 12 months.
                                    <br />
                                    No changes to your plan or features.
                                </div>
                            </div>
                        </div>
                        <div className="change-plan-special-offer-modal-footer">
                            <button
                                className="change-plan-special-offer-modal-footer-confirm"
                                onClick={this.onStayAndSave}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading && <Loading onlyPreloader />}
                                Stay and Save 25%
                            </button>
                            <button
                                className="change-plan-special-offer-modal-footer-cancel"
                                onClick={this.cancelationHandler}
                                disabled={this.state.cancelationLoading}
                            >
                                {this.state.cancelationLoading && <Loading onlyPreloader />}
                                Continue to cancel
                            </button>
                        </div>
                    </div>
                </ReactModal>
            </>
        );
    }
}

export default SpecialOfferModal;
